import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinrajsthan() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Rajasthan',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Rajasthan ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Rajasthan, delivering efficient transportation solutions for industrial zones, SEZs, IT hubs, business districts, and corporate offices across the state. Our fleet of well-maintained sedans, SUVs, MUVs, and premium vehicles ensures safe, comfortable, and on-time travel for employees, managers, engineers, clients, and top-level executives. Whether it is daily employee commute, shift-wise transportation, airport transfers, inter-city business travel, plant visits, corporate meetings, or VIP mobility, we offer seamless and hassle-free travel services. With trained chauffeurs, GPS-enabled vehicles, flexible rental plans, and dedicated operational support, Pune Corporate Cars India Private Limited ensures a premium, dependable, and professional corporate transportation experience for businesses operating anywhere in Rajasthan.',

    top: 'Top Places to Visit in Rajasthan with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Jaipur – The Pink City",
    "description": "Jaipur, Rajasthan’s capital, is famous for its royal palaces, massive forts, traditional bazaars, and heritage architecture. Iconic landmarks such as Amber Fort, City Palace, Hawa Mahal, and Jantar Mantar reflect the grandeur of Rajput rule, making Jaipur one of India’s most visited cultural destinations."
  },
  {
    "title": "Udaipur – The City of Lakes",
    "description": "Udaipur is known for its romantic lakes, white marble palaces, and scenic hill surroundings. Top attractions include City Palace, Lake Pichola, Jag Mandir, Saheliyon Ki Bari, and Fateh Sagar Lake, making it a favorite destination for weddings, photography, and peaceful vacations."
  },
  {
    "title": "Jodhpur – The Blue City",
    "description": "Jodhpur is home to the impressive Mehrangarh Fort, Umaid Bhawan Palace, and blue-painted old city lanes that give it its signature identity. The city beautifully blends desert landscapes with royal architecture and offers an authentic experience of Rajasthani heritage."
  },
  {
    "title": "Jaisalmer – The Golden City",
    "description": "Located in the heart of the Thar Desert, Jaisalmer is known for its golden sandstone forts, havelis, and desert safari experiences. Jaisalmer Fort, Sam Sand Dunes, Patwon Ki Haveli, and camel rides make it one of the most unique desert destinations in India."
  },
  {
    "title": "Mount Abu – Rajasthan’s Hill Station",
    "description": "Mount Abu offers cool weather, scenic landscapes, lakes, and Jain temples, making it Rajasthan’s only hill station. Dilwara Temples, Nakki Lake, Guru Shikhar, and serene viewpoints attract families, pilgrims, and nature lovers alike."
  },
  {
    "title": "Pushkar",
    "description": "Pushkar is a sacred town known for the famous Brahma Temple, Pushkar Lake, and the vibrant annual Camel Fair. The town blends spirituality with colorful bazaars, cultural experiences, and traditional Rajasthani hospitality."
  },
  {
    "title": "Ranthambore National Park",
    "description": "Ranthambore is one of India’s most popular wildlife reserves, famous for its Bengal tiger population, ancient fort ruins, lakes, and dense forest surroundings. Jungle safaris give visitors a chance to spot tigers, leopards, deer, crocodiles, and numerous bird species."
  },
  {
    "title": "Chittorgarh",
    "description": "Chittorgarh is known for its gigantic hilltop fort, one of the largest in India, featuring towers, palaces, temples, and water reservoirs. The fort symbolizes the courage and sacrifice of Rajput warriors and queens, including the famed story of Rani Padmini."
  },
  {
    "title": "Bikaner",
    "description": "Bikaner is famed for Junagarh Fort, Lalgarh Palace, Karni Mata Temple, desert landscapes, and vibrant local food such as Bikaneri bhujia and sweets. The city offers a mix of royal heritage, desert charm, and traditional handicrafts."
  },
  {
    "title": "Ajmer",
    "description": "Ajmer is an important pilgrimage destination, home to the revered Ajmer Sharif Dargah of Khwaja Garib Nawaz. The city features historical architecture, religious harmony, and proximity to Pushkar, making it a significant cultural stop in Rajasthan."
  }
],


"services": [
  {
    "name": "Rajasthan Corporate Transport",
    "description": "Rajasthan Corporate Transport provides end-to-end workforce mobility solutions across Rajasthan, including employee commutes, executive transfers, and business travel. Equipped with modern sedans, SUVs, and shuttle vehicles, it ensures safe, punctual, and reliable transport with GPS tracking and professional drivers."
  },
  {
    "name": "Business Cab Rajasthan",
    "description": "Business Cab Rajasthan offers premium corporate travel for meetings, client visits, airport transfers, and inter-office trips. Fleet includes well-maintained vehicles with professional chauffeurs for a comfortable and efficient business travel experience."
  },
  {
    "name": "Employee Shuttle Rajasthan",
    "description": "Employee Shuttle Rajasthan provides high-capacity shuttle services for bulk staff movement. Features include optimized routes, shift-aligned scheduling, GPS tracking, and safety protocols for organized and timely employee commutes."
  },
  {
    "name": "Office Pickup Drop Rajasthan",
    "description": "Office Pickup Drop Rajasthan offers structured daily commute services with pre-planned routes, verified drivers, and real-time tracking. Designed for companies requiring reliable, timely, and safe staff transport across Rajasthan."
  },
  {
    "name": "Monthly Corporate Cab Rajasthan",
    "description": "Monthly Corporate Cab Rajasthan delivers long-term transport solutions with dedicated vehicles, trained drivers, GPS monitoring, and maintenance support. Ideal for organizations requiring consistent daily staff movement."
  },
  {
    "name": "Affordable Corporate Cab Rajasthan",
    "description": "Affordable Corporate Cab Rajasthan provides cost-effective and reliable corporate transportation solutions for startups, SMEs, and medium-sized businesses. Ensures safe and punctual daily employee travel without compromising comfort."
  },
  {
    "name": "Best Corporate Cab Rajasthan",
    "description": "Best Corporate Cab Rajasthan offers premium travel with top-quality vehicles, expert drivers, and high safety standards. Suitable for executives, managerial staff, and VIP clients, ensuring a professional and smooth travel experience."
  },
  {
    "name": "Outstation Corporate Cab Rajasthan",
    "description": "Outstation Corporate Cab Rajasthan provides long-distance corporate travel for client visits, intercity meetings, factory tours, and executive trips. Includes comfortable vehicles, experienced chauffeurs, GPS tracking, and route planning for safe outstation mobility."
  },
  {
    "name": "Sedan Cab Rajasthan",
    "description": "Sedan Cab Rajasthan delivers executive-level sedans for managers, airport transfers, and corporate travel. Ensures comfortable, safe, and punctual journeys with professional drivers."
  },
  {
    "name": "SUV Cab Rajasthan",
    "description": "SUV Cab Rajasthan offers spacious and high-comfort SUVs suitable for team travel, senior executives, and long-distance corporate drives. Equipped with trained chauffeurs and advanced safety monitoring."
  },
  {
    "name": "Company Staff Transport Rajasthan",
    "description": "Company Staff Transport Rajasthan provides organized employee transportation with managed routes, professional drivers, and safety protocols. Ensures timely and dependable commuting for staff across corporate locations."
  },
  {
    "name": "Employee Mobility Rajasthan",
    "description": "Employee Mobility Rajasthan delivers tech-enabled, flexible commuting solutions for employees with GPS tracking, multi-shift support, and reliable transport management across Rajasthan."
  },
  {
    "name": "Corporate Fleet Rajasthan",
    "description": "Corporate Fleet Rajasthan offers fleet outsourcing and management solutions including sedans, SUVs, and shuttle vehicles. Includes driver management, maintenance, compliance tracking, and scalable fleet availability for companies."
  },
  {
    "name": "Chauffeur Service Rajasthan",
    "description": "Chauffeur Service Rajasthan provides professional drivers for executive and VIP transport, ensuring safe, punctual, and comfortable travel for corporate clients."
  },
  {
    "name": "Airport Corporate Cab Rajasthan",
    "description": "Airport Corporate Cab Rajasthan delivers reliable airport transfers for corporate employees and executives. Includes sedans, SUVs, trained chauffeurs, and GPS-enabled tracking for timely pick-ups and drop-offs."
  }
],

"tableData": [
  ["Rajasthan Corporate Transport", "Business Cab Rajasthan"],
  ["Employee Shuttle Rajasthan", "Office Pickup Drop Rajasthan"],
  ["Monthly Corporate Cab Rajasthan", "Affordable Corporate Cab Rajasthan"],
  ["Best Corporate Cab Rajasthan", "Outstation Corporate Cab Rajasthan"],
  ["Sedan Cab Rajasthan", "SUV Cab Rajasthan"],
  ["Company Staff Transport Rajasthan", "Employee Mobility Rajasthan"],
  ["Corporate Fleet Rajasthan", "Chauffeur Service Rajasthan"],
  ["Airport Corporate Cab Rajasthan", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Rajasthan",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services across Rajasthan, ensuring smooth and efficient transportation for employees and business executives throughout the state."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Rajasthan’s major cities, industrial areas, and business districts, helping employees reach offices, factories, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel anywhere in Rajasthan."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored corporate cab rental plans to meet the commuting needs of companies and employees across Rajasthan."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, providing secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking system and reliable coordination, making employee transport hassle-free."
  }
]




















  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Rajasthan?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies, offices, and corporate events across Rajasthan.',
  },
  {
    question: 'What types of corporate transportation services are available in Rajasthan?',
    answer: 'We provide employee transportation, airport transfers, corporate pickups and drops, shuttle services, outstation travel, and complete fleet management for corporate clients.',
  },
  {
    question: 'Do you support daily employee commute services in Rajasthan?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees in major industrial and business hubs of Rajasthan.',
  },
  {
    question: 'How can companies book corporate cab services in Rajasthan?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Rajasthan?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Rajasthan?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Rajasthan?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manish Rathore',
    feedback: 'Dependable corporate cab service for our offices across Rajasthan. Vehicles are clean and drivers are professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Joshi',
    feedback: 'Excellent service for corporate transportation in Rajasthan. Timely pickups and smooth rides ensure hassle-free commutes for employees.',
    rating: 5,
  },
];

















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Rajasthan",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-rajasthan.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides corporate cab services across Rajasthan, including business cabs, employee shuttles, office pickup & drop services, monthly corporate cabs, affordable corporate cabs, outstation corporate cabs, sedan & SUV corporate cabs, company staff transport, employee mobility, corporate fleet services, chauffeur services, and airport corporate transport.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-rajasthan"
  }
};









  return (
    <div>
      <Helmet>
  <title>Corporate Cab Service in Rajasthan | Employee & Business Transport</title>

  <meta
    name="description"
    content="Corporate cab services in Rajasthan including business cabs, employee shuttles, office pickup & drop, monthly corporate cabs, affordable corporate cabs, outstation corporate cabs, sedan & SUV corporate cabs, company staff transport, employee mobility, corporate fleet services, chauffeur services, and airport corporate transport."
  />

  <meta
    name="keywords"
    content="Rajasthan Corporate Transport, Business Cab Rajasthan, Employee Shuttle Rajasthan, Office Pickup Drop Rajasthan, Monthly Corporate Cab Rajasthan, Affordable Corporate Cab Rajasthan, Best Corporate Cab Rajasthan, Outstation Corporate Cab Rajasthan, Sedan Cab Rajasthan, SUV Cab Rajasthan, Company Staff Transport Rajasthan, Employee Mobility Rajasthan, Corporate Fleet Rajasthan, Chauffeur Service Rajasthan, Airport Corporate Cab Rajasthan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinrajsthan;